module.exports = __webpack_public_path__ + "img/light.34a7d5c4.svg";